import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-modal-login-manifesto',
  templateUrl: './modal-login-manifesto.component.html',
  styleUrls: ['./modal-login-manifesto.component.scss']
})
export class ModalLoginManifestoComponent implements OnInit {

  isLoading = true;
  hide = true;
  liberarAcesso: any;
  modulo: string;

  formLogin = new FormGroup({
    loginAcesso: new FormControl('', Validators.required),
    passwordAcesso: new FormControl('', Validators.required),
  });
  get usuarioAcesso() { return this.formLogin.get('loginAcesso').value; }
  get passwordAcesso() { return this.formLogin.get('passwordAcesso').value; }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialogRef<ModalLoginManifestoComponent>,
    public snackBar: MatSnackBar,
    public authService: AuthService,
  ) {
    this.modulo = data.modulo;
  }

  ngOnInit() {
  }

  liberarLogin() {
    const obj = {
      moduleName: this.modulo,
      usuario: this.usuarioAcesso,
      password: this.passwordAcesso,
    }

    this.authService.checkUserHasFeature(obj).subscribe((response: any) => {
      if (response.access === true) {
        response.error_message = this.usuarioAcesso;
        this.dialog.close(response);
      }
      else {
        if (!response.error_message) {
          this.openSnackBar('Usuário não tem permissão!', 'OK', 5000, 'danger-snackbar');
        } else {
          this.openSnackBar(response.error_message, 'OK', 5000, 'danger-snackbar');
        }
      }
    }),
      (err: HttpErrorResponse) => {
        console.error(err);
        this.isLoading = false;
        this.openSnackBar('Erro ao solicitar acesso, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      }
  }

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
